import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { HeroImage } from '../elements/HeroImage';
import { MypageFacilityCard } from '../elements/MypageFacilityCard';
import { MypageUserDetail } from '../elements/MypageUserDetail';
import { PageSection } from '@/components/elements/PageSection';
import { MainLayout } from '@/components/layouts/MainLayout';
import { ROUTE_PATH } from '@/constants/routes';
import { useUser } from '@/hooks/useUser';

export const MyPage = () => {
  const { t } = useTranslation();
  const { user, isAnaLoungeMember, isSuiteLoungeMember } = useUser();

  return (
    <MainLayout pageClassName="p-auth page_a2">
      <PageSection>
        <HeroImage src="/Common_Title.jpg" alt="LOUNGE RESERVATION" />
        <div className="l-grid">
          <section className="l-card">
            <div className="l-card__body">
              <div className="l-box">
                <MypageUserDetail
                  email={user?.email ?? ''}
                  familyName={user?.family_name_jp ?? ''}
                  firstName={user?.first_name_jp ?? ''}
                />
              </div>
            </div>
          </section>

          <section className="l-card">
            <div className="l-card__body">
              {user && (
                <MypageFacilityCard membershipType={user.membership_type} />
              )}
              <div className="l-text-group l-text-group--white">
                <p className="l-text">
                  {isAnaLoungeMember
                    ? t('myPage.info.eligibilityAnaLounge')
                    : t('myPage.info.eligibilitySuiteLounge')}
                </p>
              </div>

              <div className="l-text-group l-text-group--white">
                <p className="l-text">{t('myPage.info.workhubInfo')}</p>
              </div>
              <div className="l-media">
                <img
                  className="l-media__img"
                  src="/Common_Related_Services.png"
                  alt="workhub"
                />
              </div>
              <div className="l-related-links">
                <div className="l-related-links__item l-related-links__item--ana">
                  <div className="l-related-links__title">
                    {t('myPage.links.ana.title')}
                  </div>
                  <div className="l-related-links__links">
                    {isAnaLoungeMember && (
                      <a
                        className="link-text"
                        href={t('common.links.loungeReservation.showerRoomTermsOfUse')}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('myPage.info.showerRoomTermsOfUse')}
                      </a>
                    )}
                    {isSuiteLoungeMember && (
                      <a
                        className="link-text"
                        href={t('common.links.loungeReservation.showerAndPrivateRoomTermsOfUse')}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('myPage.info.showerAndPrivateRoomTermsOfUse')}
                      </a>
                    )}
                    <a
                      className="link-text"
                      href={t('common.links.loungeReservation.privacyPolicy')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('myPage.info.privacyPolicy')}
                    </a>
                    <br />
                  </div>
                </div>
                <div className="l-related-links__item l-related-links__item--workhub">
                  <div className="l-related-links__title">
                    {t('myPage.links.workhub.title')}
                  </div>
                  <div className="l-related-links__links">
                    <a
                      className="link-text"
                      href={t('common.links.workhub.termsOfUse')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('myPage.info.termsOfUse')}
                    </a>
                    <a
                      className="link-text"
                      href={t('common.links.workhub.privacyPolicy')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('myPage.info.privacyPolicy')}
                    </a>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="l-card">
            <div className="l-card__body">
              <div className="actions">
                <a
                  href={t('myPage.buttons.workhubPassButtonUrl')}
                  className="link-button link-button--workhub"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('myPage.buttons.workhubPassButton')}
                </a>
                <Link
                  to={ROUTE_PATH.TOP}
                  className="link-button link-button--back"
                >
                  {t('myPage.buttons.back')}
                </Link>
              </div>
            </div>
          </section>
        </div>
      </PageSection>
    </MainLayout>
  );
};
